export interface ComicCategory {
  id: string;
  name: string;
  icon: string;
  description: string;
  count: number;
  keywords: string;
}

export const categories: ComicCategory[] = [
  {
    id: 'hanman',
    name: '韩漫',
    icon: 'ri-emotion-laugh-fill',
    description: '最新韩漫无删减免费看，剧情张力与画风在线，人气韩漫每日更新。',
    count: 862,
    keywords: '韩漫,韩漫免费阅读,韩漫无删减',
  },
  {
    id: 'rexue',
    name: '热血战斗',
    icon: 'ri-fire-fill',
    description: '拳拳到肉的热血激战，少年逆袭燃向巅峰，战斗分镜张力十足。',
    count: 1135,
    keywords: '热血漫画,战斗漫画,少年热血',
  },
  {
    id: 'xuanhuan',
    name: '玄幻奇幻',
    icon: 'ri-magic-fill',
    description: '东方玄幻与西方奇幻并行，修炼升级、魔法秘境，脑洞大开的异世界之旅。',
    count: 976,
    keywords: '玄幻漫画,奇幻漫画,修炼升级',
  },
  {
    id: 'dushi',
    name: '都市生活',
    icon: 'ri-building-2-fill',
    description: '都市强者、职场情缘与烟火日常，贴近生活的精彩故事一网打尽。',
    count: 648,
    keywords: '都市漫画,都市生活,都市强者',
  },
  {
    id: 'lianai',
    name: '恋爱甜宠',
    icon: 'ri-heart-3-fill',
    description: '甜度爆表的恋爱日常与虐心纠葛，心动剧情让少女心扑通扑通。',
    count: 721,
    keywords: '恋爱漫画,甜宠漫画,少女漫画',
  },
  {
    id: 'xuanyi',
    name: '悬疑推理',
    icon: 'ri-spy-fill',
    description: '烧脑谜案与惊悚氛围拉满，层层反转的推理故事让你欲罢不能。',
    count: 453,
    keywords: '悬疑漫画,推理漫画,烧脑漫画',
  },
];

export const allCategoryId = 'all';